/**
 * RSLogo component renders a logo image based on the provided variant.
 * Variants:
 * - logo_trans_fill_white -- Primary logo with transparent background and white text fill.
 * - logo_dark_trans_fill_white -- Darker primary logo with transparent background and white text fill.
 * - logo_trans_white -- White logo with transparent background (no fill).
 * - logo_trans -- Primary logo with transparent background (no fill).
 * - logo_trans_fill -- Primary logo with green fill and transparent background.
 * - logo_white_fill -- Primary logo with white background and fill.
 * - logo_with_text_trans -- Primary logo with slogan text and transparent background (no fill).
 * - logo_with_text_white_fill -- Primary logo with slogan text with white background and fill.
 * 
 * NOTE: The logo images are stored in the assets/images directory. The variant string directly
 * references the filename of the image to display. Please add your own logo images to the assets/images
 * directory as needed and they will be accessible here (please update variants in the comment above).
 * 
 * @component
 * @param {string} classes - The CSS classes to apply to the image.
 * @param {string} variant - The variant of the logo to display.
 * @param {string} text - The alt text for the image (default = Logo).
 * @example
 * return (
 *  <RSLogo classes='h-5' variant={'logo_trans_white'} />
 * )
 */
const RSLogo = ({ classes, variant, alt = 'Logo' }) => {

  var logo = require(`../../assets/images/${variant}.png`);

  return (
    <img src={logo} alt={alt} className={classes} />
  )
}
export default RSLogo
